@if (isFlutter) {
  <app-v3-chat-trigger></app-v3-chat-trigger>
}

@if (chat.isOpen()) {
  <div class="chat-overlay" [class.expanded]="canExpand() && chat.isExpanded()">
    <section
      #dialog
      class="chat-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="v3-chat-title"
      tabindex="-1"
      [style.marginTop.px]="isFlutter ? safeAreaTop + 24 : null"
      [style.paddingBottom.px]="isFlutter ? safeAreaBottom : null"
    >
      <header class="chat-header">
        <span class="chat-avatar" aria-hidden="true">
          <span class="sparkle"></span>
        </span>
        <div class="chat-heading">
          <h2 id="v3-chat-title" class="chat-title">
            AI Chat <span class="chat-badge">Beta</span>
          </h2>
          @if (chat.companyName()) {
            <p class="chat-subtitle">{{ chat.companyName() }}</p>
          }
        </div>
        @if (canExpand()) {
          <button
            type="button"
            class="chat-expand"
            (click)="chat.toggleExpanded()"
            [attr.aria-label]="chat.isExpanded() ? 'Chat verkleinern' : 'Chat vergrößern'"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              @if (chat.isExpanded()) {
                <path d="M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7" />
              } @else {
                <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
              }
            </svg>
          </button>
        }
        <button
          type="button"
          class="chat-close"
          (click)="chat.close()"
          aria-label="AI Chat schließen"
        >
          <span class="close-icon" aria-hidden="true"></span>
        </button>
      </header>

      <div #scroller class="chat-messages" role="log" aria-live="polite">
        <div class="msg assistant">
          <p class="intro">
            Hi! Ich bin der AI Chat zu
            {{ chat.companyName() || 'dieser Aktie' }}. Frag mich etwas zu Fundamentaldaten, News,
            Analysten oder dem Wettbewerb.
          </p>
        </div>

        @if (chat.exchanges().length === 0) {
          <div class="chips" aria-label="Vorschläge">
            @for (question of suggestions; track question) {
              <button type="button" class="chip" (click)="ask(question, 'suggested')">
                {{ question }}
              </button>
            }
          </div>
        }

        @for (exchange of chat.exchanges(); track exchange.id; let last = $last) {
          <div class="msg user">{{ exchange.question }}</div>

          @switch (exchange.status) {
            @case ('pending') {
              <div class="msg assistant typing" role="status" aria-label="Antwort wird erstellt">
                <span></span><span></span><span></span>
              </div>
            }
            @case ('error') {
              <div class="msg assistant error">
                <p>{{ errorText(exchange.error) }}</p>
                @if (canRetry(exchange.error)) {
                  <button
                    type="button"
                    class="retry"
                    [disabled]="chat.pending()"
                    (click)="chat.retry(exchange.id)"
                  >
                    Erneut versuchen
                  </button>
                }
              </div>
            }
            @case ('done') {
              <div class="msg assistant">
                <div class="answer" [innerHTML]="exchange.html | textClean"></div>
                @if (notes(exchange).length) {
                  <ul class="notes">
                    @for (note of notes(exchange); track note) {
                      <li>{{ note }}</li>
                    }
                  </ul>
                }
                @if (metaText(exchange)) {
                  <p class="meta">{{ metaText(exchange) }}</p>
                }
              </div>
              @if (last && exchange.response?.follow_up_questions?.length) {
                <div class="chips" aria-label="Folgefragen">
                  @for (question of exchange.response!.follow_up_questions; track question) {
                    <button type="button" class="chip" (click)="ask(question, 'follow_up')">
                      {{ question }}
                    </button>
                  }
                </div>
              }
            }
          }
        }
      </div>

      <form class="chat-composer" (submit)="onSubmit($event)">
        <textarea
          #textarea
          class="chat-input"
          rows="1"
          [attr.maxlength]="maxChars"
          [placeholder]="placeholder()"
          [value]="draft()"
          (input)="onInput($event)"
          (keydown)="onInputKeydown($event)"
          aria-label="Deine Frage"
        ></textarea>
        <button type="submit" class="chat-send" [disabled]="!canSend()" aria-label="Frage senden">
          <svg
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M10 16V4m0 0 5 5m-5-5-5 5" />
          </svg>
        </button>
      </form>
      <p class="chat-disclaimer">
        KI-generiert, keine Anlageberatung. Jede Frage wird für sich beantwortet.
      </p>
    </section>
  </div>
}
